import LocalStorageService from '@application/common/local-storage-service';
import { getErrorPayload } from '@application/helpers/api-helper';
import AuthApi from '@infrastructure/auth-api';
import collaboratorAPI from '@infrastructure/collaborator-api';
import { createAsyncThunk } from '@reduxjs/toolkit';
export const loginAsync = createAsyncThunk('auth/login', async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await AuthApi.login();
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const refreshTokenAsync = createAsyncThunk('auth/refreshToken', async (_, { rejectWithValue }) => {
    try {
        const refreshTokenRequest = {
            accessToken: LocalStorageService.getAccessToken()
        };
        const response = await AuthApi.getRefreshToken(refreshTokenRequest);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const verifyTokenAsync = createAsyncThunk('auth/verifyToken', async (VerifyTokenDto, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await AuthApi.verifyToken(VerifyTokenDto);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const fetchCollaboratorNDAStatusAsync = createAsyncThunk('auth/fetchCollaboratorNDAStatus', async (userId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await collaboratorAPI.getCollaboratorByUserId(userId);
        return fulfillWithValue(response.data.isNDASigned ?? false);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
